import { render, staticRenderFns } from "./PositionList.vue?vue&type=template&id=1f15f805&scoped=true"
import script from "./PositionList.vue?vue&type=script&lang=js"
export * from "./PositionList.vue?vue&type=script&lang=js"
import style0 from "./PositionList.vue?vue&type=style&index=0&id=1f15f805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f15f805",
  null
  
)

export default component.exports